import { Headline3 } from 'aimo-ui';
import ParkAndChargeTariffItem from 'components/park/tariff/ParkAndChargeTariffItem';
import useEVChargingPricingInfo from 'hooks/useEvChargingPricingInfo';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { ParkingZoneType } from 'types/common';
import {
  ChargingStation,
  CountryCode,
  SegmentProps,
} from 'types/generatedSchemaTypes';

const ParkAndChargeTariffSection = ({
  chargingStations,
  selectedTariffId,
  countryCode,
  zoneCode,
  onPress,
}: {
  chargingStations: ChargingStation[];
  selectedTariffId?: string;
  countryCode: CountryCode;
  zoneCode?: string;
  onPress: (
    tariffId: string,
    tariffName: string,
    type: ParkingZoneType,
    chargingSegment?: SegmentProps,
    isUnlockValid?: boolean
  ) => void;
}) => {
  const { t } = useTranslation();

  const { pricingSegmentsEv } = useEVChargingPricingInfo({
    chargingStations: chargingStations || [],
  });

  return (
    <StyledWrapper mb={30}>
      <Headline3 testID="tariff-parkAndCharge-title">
        {t('parking.tariff.typeCharge')}
      </Headline3>
      {pricingSegmentsEv.map((segment) => (
        <ParkAndChargeTariffItem
          segment={segment}
          countryCode={countryCode}
          zoneCode={zoneCode}
          isSelected={selectedTariffId === segment?.tariffPlanId}
          key={segment?.tariffPlanId}
          onPress={(tariffId, tariffName, type, isUnlockValid) =>
            onPress(
              tariffId,
              tariffName,
              type,
              segment as SegmentProps,
              isUnlockValid
            )
          }
        />
      ))}
    </StyledWrapper>
  );
};

export default ParkAndChargeTariffSection;
